var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 7.5H4.25C3.83579 7.5 3.5 7.16421 3.5 6.75C3.5 6.33579 3.83579 6 4.25 6H19.25C19.6642 6 20 6.33579 20 6.75C20 7.16421 19.6642 7.5 19.25 7.5ZM4.25 13H19.25C19.6642 13 20 12.6642 20 12.25C20 11.8358 19.6642 11.5 19.25 11.5H4.25C3.83579 11.5 3.5 11.8358 3.5 12.25C3.5 12.6642 3.83579 13 4.25 13ZM4.25 18.5H19.25C19.6642 18.5 20 18.1642 20 17.75C20 17.3358 19.6642 17 19.25 17H4.25C3.83579 17 3.5 17.3358 3.5 17.75C3.5 18.1642 3.83579 18.5 4.25 18.5Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.e27f67a72e9a2effe1d02f2d2ea064bb.svg";
export { ForwardRef as ReactComponent };